import type { FC, ReactNode } from "react";
import { useAnnieAvatar } from "@/hooks/useAnnieAvatar";
import { ASSISTANT_AVATAR } from "@/theme/tokens";
import { AssistantAvatar } from "@/ui/AssistantAvatar/AssistantAvatar";
import { AssistantAvatarMood } from "@/ui/AssistantAvatar/assistantAvatarConfig";

const MENU_AVATAR_SIZE = ASSISTANT_AVATAR.SIZE.MENU;

type Props = {
	/** The icon shown when the user has no visible Annie design. */
	standardIcon: ReactNode;
};

/** The Annie menu entry's icon: the user's Annie (still), or the standard icon. */
export const AnnieMenuIcon: FC<Props> = ({ standardIcon }) => {
	const { visibleConfig } = useAnnieAvatar();
	if (visibleConfig === null) return standardIcon;
	return (
		<AssistantAvatar config={visibleConfig} mood={AssistantAvatarMood.Idle} size={MENU_AVATAR_SIZE} animated={false} dataTestId="admin-menu-annie-avatar" />
	);
};
